export default "__VITE_ASSET__Dvd5goqA__"